import React from "react";
import { useDispatch } from "react-redux";
import { Grid, Card, CardContent, IconButton, Tooltip } from "@deere/fuel-react";
import { Form } from "@deere/ux.uxframe-react";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import { ST_CATALOGUE_TIERLEVEL, ST_CATALOGUE_PRODUCTTYPE, ST_CATALOGUE_DIVERSITYTYPE, TIER_LEVEL_TOOLTIP, PRODUCT_TYPE_TOOLTIP } from "../../utils/surveyLiterals";
import { editSTSupplierData } from "../../redux/action/subTierSurveyAction";

const SupplierDataCard = ({ data, countries, states, getStatesForNewRow, showActions, catalogueData, openDeleteModal, index }) => {
  const dispatch = useDispatch();
  let optTierLevel = catalogueData ? (catalogueData.length > 0 ? catalogueData[0][ST_CATALOGUE_TIERLEVEL] : []) : [];
  let optProdType = catalogueData ? (catalogueData.length > 0 ? catalogueData[1][ST_CATALOGUE_PRODUCTTYPE] : []) : [];
  let optDiversityType = catalogueData ? (catalogueData.length > 0 ? catalogueData[2][ST_CATALOGUE_DIVERSITYTYPE] : []) : [];

  let optState = [];
  if (data.country !== "" && countries && states) {
    let country = countries.find((cntry) => cntry.value === data.country);
    if (country) {
      let state = states.find((st) => st.code === country.code);
      if (state) optState = state.states;
    }
  }

  const handleOnBlur = (event) => {
    if (event.target.name === "country") {
      let country = countries.find((cntry) => cntry.value === event.target.value);
      if(country) getStatesForNewRow(country.code);
    }
    dispatch(editSTSupplierData({ id: data.id, field: event.target.name, value: event.target.value }));
  };

  return (
    <Card borderRadius="none" sx={{ color: "grey", border: "1px solid grey", boxShadow: "none", padding: "10px", backgroundColor: `${index % 2 === 0 ? "#e5e5e5" : "white"}` }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">Supplier Name</Form.Label>
            {showActions ? <Form.Control defaultValue={data?.supplierName} name="supplierName" required onBlur={handleOnBlur}></Form.Control> : <p>{data?.supplierName}</p>}
          </Grid>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">Street Address</Form.Label>
            {showActions ? <Form.Control defaultValue={data?.streetAddress} name="streetAddress" required onBlur={handleOnBlur}></Form.Control> : <p>{data?.streetAddress}</p>}
          </Grid>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">Country</Form.Label>
            {showActions ? (
              <Form.Control as="select" required defaultValue={data.country} name="country" onBlur={handleOnBlur}>
                <option value="" hidden>
                  Select
                </option>
                {countries.map((i) => (
                  <option key={i.code} value={i.value}>
                    {i.label}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <p>{data.country}</p>
            )}
          </Grid>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">City</Form.Label>
            {showActions ? <Form.Control defaultValue={data.city} required name="city" onBlur={handleOnBlur}></Form.Control> : <p>{data.city}</p>}
          </Grid>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">State</Form.Label>
            {showActions ? (
              <Form.Control as="select" required={optState.length > 0 ? true : false} disabled={optState.length > 0 ? false : true} defaultValue={data.state} name="state" onBlur={handleOnBlur}>
                <option value="" hidden>
                  {optState.length > 0 ? "Select" : "-NA-"}
                </option>
                {optState.map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <p>{data.state}</p>
            )}
          </Grid>
          <Grid item xs={2}>
            <Form.Label className="uxf-label">Postal Code</Form.Label>
            {showActions ? <Form.Control defaultValue={data.postalCode} required name="postalCode" onBlur={handleOnBlur}></Form.Control> : <p>{data.postalCode}</p>}
          </Grid>
          <Grid item xs={2}>
            <Tooltip title={<div dangerouslySetInnerHTML={{ __html: TIER_LEVEL_TOOLTIP }} />} placement="top">
              <Form.Label className="uxf-label">Tier Level</Form.Label>
            </Tooltip>
            {showActions ? (
              <Form.Control as="select" required defaultValue={data.tierLevel} name="tierLevel" onBlur={handleOnBlur}>
                <option value="" hidden>
                  Select
                </option>
                {optTierLevel.map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <p>{data.tierLevel}</p>
            )}
          </Grid>
          <Grid item xs={4}>
            <Tooltip title={PRODUCT_TYPE_TOOLTIP} placement="top">
              <Form.Label className="uxf-label">Product Type</Form.Label>
            </Tooltip>
            {showActions ? (
              <Form.Control as="select" required defaultValue={data.productType} name="productType" onBlur={handleOnBlur}>
                <option value="" hidden>
                  Select
                </option>
                {optProdType.map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <p>{data.productType}</p>
            )}
          </Grid>
          <Grid item xs={5}>
            <Form.Label className="uxf-label">
              <span style={{ fontSize: "0.8rem" }}>U.S. SUPPLIERS ONLY. Is this entity considered a diverse enterprise?</span>
            </Form.Label>
            {showActions ? (
              <Form.Control as="select" defaultValue={data.isDiverseEnterprise} name="isDiverseEnterprise" onBlur={handleOnBlur}>
                <option value="" hidden>
                  Select
                </option>
                {optDiversityType.map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <p>{data.isDiverseEnterprise}</p>
            )}
          </Grid>
          {showActions && (
            <Grid item xs={1} style={{ position: "relative" }}>
              <IconButton
                outlined
                style={{ position: "absolute", bottom: "0", right: "0" }}
                onClick={() => {
                  openDeleteModal(data);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SupplierDataCard;
